import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Card, CardHeader, CardTitle, CardContent } from "../components/ui/card";
import { Loader2, ShieldCheck } from "lucide-react";

export default function AuthCallback({ backendUrl }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const run = async () => {
      const code = searchParams.get("code");
      const err = searchParams.get("error");

      if (err) {
        setError(`Google OAuth error: ${err}`);
        setTimeout(() => navigate("/admin/login"), 2500);
        return;
      }

      if (!code) {
        setError("Kode otorisasi tidak ditemukan.");
        setTimeout(() => navigate("/admin/login"), 2500);
        return;
      }

      const verifier = window.sessionStorage.getItem("hti_oauth_verifier");
      if (!verifier) {
        setError("Sesi login sudah kedaluwarsa. Silakan coba lagi.");
        setTimeout(() => navigate("/admin/login"), 2500);
        return;
      }

      try {
        const payload = {
          code,
          code_verifier: verifier,
        };
        const res = await axios.post(`${backendUrl}/api/auth/google`, payload);
        const token = res.data?.access_token;

        if (!token) {
          setError("Token admin tidak ditemukan dalam respons.");
          setTimeout(() => navigate("/admin/login"), 2500);
          return;
        }

        window.localStorage.setItem("hti_admin_token", token);
        window.sessionStorage.removeItem("hti_oauth_verifier");
        navigate("/admin/leads");
      } catch (e) {
        console.error(e);
        const msg = e.response?.data?.detail || "Gagal memproses login admin.";
        setError(msg);
        setTimeout(() => navigate("/admin/login"), 2500);
      }
    };

    if (backendUrl) {
      run();
    } else {
      setError("Backend URL belum dikonfigurasi.");
      setTimeout(() => navigate("/admin/login"), 2500);
    }
  }, [backendUrl, navigate, searchParams]);

  return (
    <div className="min-h-screen bg-slate-50 px-4 py-10 text-slate-900 sm:px-6 lg:px-8">
      <div className="mx-auto flex max-w-md flex-col gap-6">
        <Card className="border-slate-200 bg-white">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-base">
              <ShieldCheck className="h-4 w-4 text-emerald-500" />
              <span>Memverifikasi Login Admin</span>
            </CardTitle>
          </CardHeader>
          <CardContent className="flex flex-col items-center gap-3 text-xs text-slate-600">
            {!error && (
              <>
                <Loader2 className="h-4 w-4 animate-spin text-slate-700" />
                <p>Harap tunggu, kami sedang memverifikasi kredensial Google Anda...</p>
              </>
            )}
            {error && (
              <p className="text-red-600 text-center">{error}</p>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
